export default __webpack_public_path__ + "static/media/Animals_12.65814d21.png";